import { pick, without, keys } from 'ramda';

/*
  Blacklist function, takes a list of keys and an object. Returns new object without the specified keys
  Signature: ([k], {k: v}) -> {k: v}
 */

export default (list = [], obj = {}) => pick(without(list, keys(obj)), obj);
